import { Col, Row, Typography } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import cohort from '../../assets/mode-selection/cohortanalysis.png'
import ecom from '../../assets/ecom.png'
import Item1 from '../../assets/mode-selection/item-1.png'
import Item2 from '../../assets/mode-selection/item-2.png'
import Campaign from '../../assets/mode-selection/campaign.png'
import Sync from '../../assets/mode-selection/sync.png'
import Actionable from '../../assets/mode-selection/alerts.png'
import ConditionalBased from '../../assets/mode-selection/conditionalbased.png'
import nps from '../../assets/mode-selection/NPS-Icon.png'

function HomeItems() {
  const navigate = useNavigate()

  return (
    <div>
      <Row>
        <Col
          style={{
            scrollY: 10,
          }}
        >
          <ul>
            {[
              { icon: Item1, title: 'Synopsis', link: '/synopsis-list' },
              { icon: Item2, title: 'Home', link: '/home' },
              {
                icon: Campaign,
                title: 'Campaigns',
                link: '/campaign-list',
              },
              { icon: Actionable, title: 'Actionable Insights', link: '/actionable' },
              { icon: cohort, title: 'Cohort Analysis', link: '/cohort-analysis-campaigns' },
              { icon: ecom, title: 'Reports', link: '/reports' },
              {
                icon: nps,
                title: 'NPS',
                link: '/feedbackanalytics',
              },
              { icon: Sync, title: 'Sync', link: '/sync' },
              {
                icon: ConditionalBased,
                title: 'Cluster Building',
                link: '/condition-based-campaign',
              },
            ].map((item, index) => (
              <Col key={index}>
                <li
                  onClick={() => {
                    navigate(item.link)
                  }}
                  style={{
                    cursor: 'pointer',
                    display: 'block',
                    height: '6rem',
                  }}
                >
                  <img
                    src={item.icon}
                    style={
                      index == 3
                        ? { width: '3rem', height: '3rem' }
                        : index == 2
                        ? { width: '3rem', height: '3rem' }
                        : { width: '3rem', height: '3rem' }
                    }
                  ></img>
                  <Typography.Text
                    className='color-white'
                    style={{
                      fontSize: 14,
                      marginLeft: 10,
                    }}
                  >
                    {item.title}
                  </Typography.Text>
                </li>
              </Col>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  )
}

export default HomeItems
